import { initializeApp, getApps, getApp } from "firebase/app";
import { getMessaging, getToken, isSupported, onMessage } from "firebase/messaging";
import { getAuth, RecaptchaVerifier } from "firebase/auth";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};



const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export function ensureRecaptcha(containerId = "recaptcha-container") {
  try {
    if (window.recaptchaVerifier) {
      // clear stale instance if exists
      try { window.recaptchaVerifier.clear(); } catch {}
      window.recaptchaVerifier = null;
    }
    window.recaptchaVerifier = new RecaptchaVerifier(auth, containerId, {
      size: "invisible",
    });
    return window.recaptchaVerifier;
  } catch (e) {
    // surface config issues early during development
    // eslint-disable-next-line no-console
    console.error("Failed to initialize reCAPTCHA. Check Firebase Web config and authorized domains.", e);
    throw e;
  }
}

// Firebase Cloud Messaging setup
let messagingPromise = null;
export async function initMessaging() {
  try {
    if (!messagingPromise) messagingPromise = isSupported().then((ok) => ok ? getMessaging(app) : null);
    const messaging = await messagingPromise;
    return messaging;
  } catch {
    return null;
  }
}

export async function requestFcmPermissionAndToken(vapidKey) {
  try {
    const messaging = await initMessaging();
    if (!messaging) return null;
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;
    // Ensure the messaging service worker is registered
    let swReg = null;
    try {
      swReg = await navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/firebase-messaging-sw.js`);
    } catch (e) {
      console.error('Failed to register firebase-messaging-sw.js', e);
    }
    const token = await getToken(messaging, { vapidKey, serviceWorkerRegistration: swReg || undefined });
    return token;
  } catch (e) {
    console.error('Failed to get FCM token', e);
    return null;
  }
}

export function onForegroundMessage(handler) {
  initMessaging().then((messaging) => {
    if (!messaging) return;
    try { onMessage(messaging, handler); } catch {}
  });
}


